export const blockIconsHouseholdCoffeeMakerNew = (
	<span className='material-symbols-outlined'>coffee_maker</span>
);
